import "../About/About.css";
import { FaUserPlus } from "react-icons/fa";
import QuickCount from "./Quickcount";


const About = () => {
    return(
        <>
            <div className="container">
                <div className="row mt-5 mb-5">
                    <div className="col-lg-7 col-md-7 col-sm-12">
                        <h1 className="about-heading">About Us</h1>
                        <p className="about-para ms-5">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec luctus eros at ex laoreet, ac auctor nulla ornare. Aenean hendrerit neque nec lectus ultrices, et euismod ipsum laoreet. Phasellus commodo mi et risus lobortis tincidunt. Nam quis odio dictum, tempor justo sed, suscipit mauris. Suspendisse vehicula ligula vel leo dapibus placerat. In efficitur lectus interdum imperdiet aliquam. Aliquam ullamcorper elit lectus, eget aliquet nunc pretium id.
                        </p>
                        <button className="btn text-uppercase text-white" id="about-button">Our Programs</button>
                    </div>
                    <div className="col-lg-5 col-md-5 col-sm-12">
                        <img src="../PICS/1.png" className="img-fluid"/>
                    </div>
                </div>
            </div>

            <div className="container">
                <h1 className="about-heading text-center mb-5">Activities</h1>
                <div className="row mb-5">
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="card pt-5 pb-5" id="About-card">
                            <div class="card-body text-center">
                                <img src="../PICS/6.png" className="card-img-top mb-3" id="About-card-img"/>
                                <h5 className="card-title text-white">Card title</h5>
                                <div className="d-flex justify-content-center mt-3 mb-3">
                                    <div className="wavy-line"></div>
                                </div>
                                <p className="card-text text-white">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button className="btn text-white" id="about-button-1">Go somewhere</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="card pt-5 pb-5" id="About-card-1">
                            <div class="card-body text-center">
                                <img src="../PICS/6.png" className="card-img-top mb-3" id="About-card-img"/>
                                <h5 className="card-title text-white">Card title</h5>
                                <div className="d-flex justify-content-center mt-3 mb-3">
                                    <div className="wavy-line-1"></div>
                                </div>
                                <p className="card-text text-white">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button className="btn text-white" id="about-button-1">Go somewhere</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="card pt-5 pb-5" id="About-card-2">
                            <div class="card-body text-center">
                                <img src="../PICS/6.png" className="card-img-top mb-3" id="About-card-img"/>
                                <h5 className="card-title text-white">Card title</h5>
                                <div className="d-flex justify-content-center mt-3 mb-3">
                                    <div className="wavy-line"></div>
                                </div>
                                <p className="card-text text-white">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button className="btn text-white" id="about-button-1">Go somewhere</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="card pt-5 pb-5" id="About-card">
                            <div class="card-body text-center">
                                <img src="../PICS/6.png" className="card-img-top mb-3" id="About-card-img"/>
                                <h5 className="card-title text-white">Card title</h5>
                                <div className="d-flex justify-content-center mt-3 mb-3">
                                    <div className="wavy-line"></div>
                                </div>
                                <p className="card-text text-white">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button className="btn text-white" id="about-button-1">Go somewhere</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-0"></div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="card pt-5 pb-5" id="About-card-2">
                            <div class="card-body text-center">
                                <img src="../PICS/6.png" className="card-img-top mb-3" id="About-card-img"/>
                                <h5 className="card-title text-white">Card title</h5>
                                <div className="d-flex justify-content-center mt-3 mb-3">
                                    <div className="wavy-line"></div>
                                </div>
                                <p className="card-text text-white">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button className="btn text-white" id="about-button-1">Go somewhere</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="card pt-5 pb-5" id="About-card">
                            <div class="card-body text-center">
                                <img src="../PICS/6.png" className="card-img-top mb-3" id="About-card-img"/>
                                <h5 className="card-title text-white">Card title</h5>
                                <div className="d-flex justify-content-center mt-3 mb-3">
                                    <div className="wavy-line"></div>
                                </div>
                                <p className="card-text text-white">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button className="btn text-white" id="about-button-1">Go somewhere</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-12">
                        <div className="card pt-5 pb-5" id="About-card-1">
                            <div class="card-body text-center">
                                <img src="../PICS/6.png" className="card-img-top mb-3" id="About-card-img"/>
                                <h5 className="card-title text-white">Card title</h5>
                                <div className="d-flex justify-content-center mt-3 mb-3">
                                    <div className="wavy-line-1"></div>
                                </div>
                                <p className="card-text text-white">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button className="btn text-white" id="about-button-1">Go somewhere</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-0"></div>
                </div>
            </div>

            <div className="container mb-5">
                <h1 className="about-heading mb-5 mt-5">Why Choose Us</h1>
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h4 className="mb-4">Question and Answer</h4>
                        <div className="accordion" id="accordionExample">
                            <div className="accordion-item border-0">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Accordion Item #1
                                    </button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item border-0">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Accordion Item #2
                                    </button>
                                </h2>
                                <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item border-0">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        Accordion Item #3
                                    </button>
                                </h2>
                                <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h4 className="mb-4">Class hour per year</h4>
                        <div>
                            <ul className="list-unstyled d-flex">
                                <li className="me-auto">Art Classes</li>
                                <li className="ms-auto">75 hrs</li>
                            </ul>
                            <div class="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning"></div>
                            </div>
                        </div>
                        <div className="mt-4">
                            <ul className="list-unstyled d-flex">
                                <li className="me-auto">Math Classes</li>
                                <li className="ms-auto">75 hrs</li>
                            </ul>
                            <div class="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning"></div>
                            </div>
                        </div>
                        <div className="mt-4">
                            <ul className="list-unstyled d-flex">
                                <li className="me-auto">Science Classes</li>
                                <li className="ms-auto">75 hrs</li>
                            </ul>
                            <div class="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning"></div>
                            </div>
                        </div>
                        <div className="mt-4">
                            <ul className="list-unstyled d-flex">
                                <li className="me-auto">Geography Classes</li>
                                <li className="ms-auto">75 hrs</li>
                            </ul>
                            <div class="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning"></div>
                            </div>
                        </div>
                        <div className="mt-4">
                            <ul className="list-unstyled d-flex">
                                <li className="me-auto">English Classes</li>
                                <li className="ms-auto">75 hrs</li>
                            </ul>
                            <div class="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-back-img">
                <div className="container">
                    <div className="row">
                        <h1 className="text-center mt-5">What we have achived</h1>
                        <h4 className="text-center mt-3">Exploring the new</h4>
                        <div className="row col-lg-3 col-md-6 col-sm-6" id="archive">
                            <div className="col-sm-6"><QuickCount limit={2344} /></div>
                            <div className="col-sm-6 mt-4"> students</div>
                        </div>
                        <div className="row col-lg-3 col-md-6 col-sm-6" id="archive">
                            <div className="col-sm-6"><QuickCount limit={44} /></div>
                            <div className="col-sm-6 mt-4"> Teachers and Staff</div>
                        </div>
                        <div className="row col-lg-3 col-md-6 col-sm-6" id="archive">
                            <div className="col-sm-6"><QuickCount limit={344} /></div>
                            <div className="col-sm-6 mt-4"> classes</div>
                        </div>
                        <div className="row col-lg-3 col-md-6 col-sm-6" id="archive">
                            <div className="col-sm-6"><QuickCount limit={23} /></div>
                            <div className="col-sm-6 mt-4"> Labs</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-5 mb-5">
                <h1 className="about-heading text-center mb-5">Meet Our Teachers</h1>
                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <div class="card border-0">
                            <img src="../PICS/teacher.jpeg" class="card-img-top" alt="..."/>
                            <div class="card-body text-center">
                                <h5 class="card-title">Samantha ma'am</h5>
                                <h6 className="text-primary">Math Teacher</h6>
                            </div>
                        </div>      
                    </div>                   
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <div class="card border-0">
                            <img src="../PICS/teacher.jpeg" class="card-img-top" alt="..."/>
                            <div class="card-body text-center">
                                <h5 class="card-title">Samantha ma'am</h5>
                                <h6 className="text-primary">English Teacher</h6>
                            </div>
                        </div>      
                    </div>                   
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <div class="card border-0">
                            <img src="../PICS/teacher.jpeg" class="card-img-top" alt="..."/>
                            <div class="card-body text-center">
                                <h5 class="card-title">Samantha ma'am</h5>
                                <h6 className="text-primary">Science Teacher</h6>
                            </div>
                        </div>      
                    </div>                   
                    <div className="col-lg-3 col-md-3 col-sm-6">
                        <div class="card border-0">
                            <img src="../PICS/teacher.jpeg" class="card-img-top" alt="..."/>
                            <div class="card-body text-center">
                                <h5 class="card-title">Samantha ma'am</h5>
                                <h6 className="text-primary">Geography Teacher</h6>
                            </div>
                        </div>      
                    </div>                   
                </div>
            </div>
        </>
    )
}

export default About;